import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=9c98e5d6&scoped=true&"
import script from "./tip.vue?vue&type=script&lang=ts&"
export * from "./tip.vue?vue&type=script&lang=ts&"
import style0 from "./tip.vue?vue&type=style&index=0&id=9c98e5d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c98e5d6",
  null
  
)

export default component.exports